import angular from 'angular';
import './modals/organization-information-screens';
import '../services/errors';
import '../services/organization-information-screen';
import '../services/notifications';

const module = angular.module('whyline.controllers.organization-information-screens', [
  'whyline.modals.organization-information-screen',
  'whyline.services.errors',
  'whyline.services.organization-information-screen',
  'whyline.services.notifications',
]);

const OrganizationInformationScreensController = ($scope, $translate, $uibModal, currentOrganization, dialog, OrganizationInformationScreenService) => {
  $scope.organizationInformationScreens = OrganizationInformationScreenService.GetAll();
  $scope.quantityOfItems = 8;
  $scope.title = 'Organization Information Screens';

  $scope.switch = organizationInformationScreen => {
    let isActiveInPlaces = organizationInformationScreen.isActive;
    let isActive = !organizationInformationScreen.isActive;

    OrganizationInformationScreenService.Switch(organizationInformationScreen, isActive, isActiveInPlaces).then(response => {
      if (response.data) {
        isActiveInPlaces = true;
        isActive = response.data.isActive;

        const confirmMessage = isActive ? 'organization-information-screens-enable-all-places' : 'organization-information-screens-disable-all-places';

        dialog.confirm($translate.instant(confirmMessage)).then(() => {
          OrganizationInformationScreenService.Switch(organizationInformationScreen, isActive, isActiveInPlaces);
        }).catch(() => {
          OrganizationInformationScreenService.Switch(organizationInformationScreen, !isActive, isActiveInPlaces);
        });
      }
    });
  };

  $scope.open = organizationInformationScreenId => {
    $uibModal.open({
      templateUrl: '/templates/components/modals/organization-information-screens-modal.html',
      size: 'lg',
      controller: 'OrganizationInformationScreenModalController',
      resolve: {
        organizationInformationScreenId: () => organizationInformationScreenId,
        currentOrganization,
      }
    });
  };
};

module.exports = module.controller('OrganizationInformationScreensController', OrganizationInformationScreensController);
